import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openButton", "closeButton"]

  connect() {
    // Ensure menu is hidden on load
    this.menuTarget.classList.add("hidden")
    
    // Close menu on window resize to desktop size
    this.resizeHandler = this.handleResize.bind(this)
    window.addEventListener("resize", this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
  }

  handleResize() {
    // Close mobile menu if window is resized to desktop size (768px+)
    if (window.innerWidth >= 768 && !this.menuTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.menuTarget.classList.add("mobile-menu-enter")
    this.openButtonTarget.classList.add("hidden")
    this.closeButtonTarget.classList.remove("hidden")
    this.openButtonTarget.setAttribute("aria-expanded", "true")
    this.closeButtonTarget.setAttribute("aria-expanded", "true")
    // Prevent body scroll when menu is open
    document.body.style.overflow = "hidden"
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.menuTarget.classList.remove("mobile-menu-enter")
    this.openButtonTarget.classList.remove("hidden")
    this.closeButtonTarget.classList.add("hidden")
    this.openButtonTarget.setAttribute("aria-expanded", "false")
    this.closeButtonTarget.setAttribute("aria-expanded", "false")
    // Restore body scroll
    document.body.style.overflow = ""
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }
}
